/**
 * Cliente para a edge function transcribe-feedback-audio.
 * Recebe um Blob de áudio (MediaRecorder) e devolve transcrição em pt-BR.
 */

import { supabase } from "@/lib/supabase/client"

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string

export async function transcribeFeedbackAudio(audioBlob: Blob): Promise<string> {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  if (!session?.access_token) {
    throw new Error("Sessão expirada. Entre novamente.")
  }

  const formData = new FormData()
  formData.append("audio", audioBlob, "feedback-audio.webm")

  const res = await fetch(`${SUPABASE_URL}/functions/v1/transcribe-feedback-audio`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${session.access_token}`,
    },
    body: formData,
  })

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: "Erro desconhecido" }))
    throw new Error(err.message || "Falha na transcrição")
  }

  const { transcript } = await res.json()
  return (transcript ?? "").trim()
}
